import { FC } from "react";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import dayjs from "dayjs";
import { TimeValidationError } from "@mui/x-date-pickers/models";
import iconBtnAdd from "./../../../../assets/_AddCircleIcon_.svg";
import { ButtonDeleted } from "../../../../components/ButtonDeleted";
import Button from "@mui/material/Button";
import styles from "./styles.module.scss";

interface DaysOfTheWeekProps {
  infoDay: {
    totalTime: number | null;
    dayOfWeek: number;
    startTime1: string | null;
    endTime1: string | null;
    startTime2: string | null;
    endTime2: string | null;
  };
  addNewField(dayOfWeek: number): void;
  removeField(dayOfWeek: number, slot: 1 | 2): void;
  updateField(
    dayOfWeek: number,
    slot: 1 | 2,
    typeField: "startTime" | "endTime",
    newValue: string | null
  ): void;
  setErrorStartTime1: React.Dispatch<React.SetStateAction<TimeValidationError>>;
  setErrorEndTime1: React.Dispatch<React.SetStateAction<TimeValidationError>>;
  setErrorStartTime2: React.Dispatch<React.SetStateAction<TimeValidationError>>;
  setErrorEndTime2: React.Dispatch<React.SetStateAction<TimeValidationError>>;
}

export const DaysOfTheWeek: FC<DaysOfTheWeekProps> = ({
  infoDay,
  addNewField,
  removeField,
  updateField,
  setErrorStartTime1,
  setErrorEndTime1,
  setErrorStartTime2,
  setErrorEndTime2,
}) => {
  function formatDaysOfTheWeekInWriting(day: number): string {
    const optionsDays: Record<number, string> = {
      0: "Domingo",
      1: "Segunda-feira",
      2: "Terça-feira",
      3: "Quarta-feira",
      4: "Quinta-feira",
      5: "Sexta-feira",
      6: "Sábado",
    };

    return optionsDays[day] || "";
  }

  return (
    <div className={styles.daysOfTheWeek}>
      <div className={styles.left}>
        <p>{formatDaysOfTheWeekInWriting(infoDay.dayOfWeek)}</p>
        <div>
          {(!infoDay.startTime1 || !infoDay.startTime2) && (
            <Button
              variant="contained"
              color="primary"
              onClick={() => addNewField(infoDay.dayOfWeek)}
              className={styles.btnAdd}
            >
              <img src={iconBtnAdd} alt="" />
            </Button>
          )}
        </div>
      </div>

      <div className={styles.right}>
        {infoDay.startTime1 || infoDay.endTime2 ? (
          <>
            {infoDay.startTime1 && (
              <div className={styles.timeFields}>
                <TimePicker
                  value={dayjs(`2024-01-01T${infoDay.startTime1}`).tz(
                    "America/Sao_Paulo"
                  )}
                  label="De"
                  onError={(newError) => setErrorStartTime1(newError)}
                  maxTime={dayjs(`2024-01-01T${infoDay.endTime1}`)
                    .subtract(1, "hour")
                    .tz("America/Sao_Paulo")}
                  onChange={(value) =>
                    updateField(
                      infoDay.dayOfWeek,
                      1,
                      "startTime",
                      value ? value.tz("America/Sao_Paulo").format() : ""
                    )
                  }
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                />
                <TimePicker
                  value={dayjs(`2024-01-01T${infoDay.endTime1}`).tz(
                    "America/Sao_Paulo"
                  )}
                  label="Até"
                  onError={(newError) => setErrorEndTime1(newError)}
                  minTime={dayjs(`2024-01-01T${infoDay.startTime1}`)
                    .add(1, "hour")
                    .tz("America/Sao_Paulo")}
                  onChange={(value) =>
                    updateField(
                      infoDay.dayOfWeek,
                      1,
                      "endTime",
                      value ? value.tz("America/Sao_Paulo").format() : ""
                    )
                  }
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                />
                <ButtonDeleted
                  handleDeleteItem={() => removeField(infoDay.dayOfWeek, 1)}
                />
              </div>
            )}

            {infoDay.startTime2 && (
              <div className={styles.timeFields}>
                <TimePicker
                  value={dayjs(`2024-01-01T${infoDay.startTime2}`).tz(
                    "America/Sao_Paulo"
                  )}
                  label="De"
                  onError={(newError) => setErrorStartTime2(newError)}
                  minTime={dayjs(`2024-01-01T${infoDay.endTime1}`)
                    .add(1, "hour")
                    .tz("America/Sao_Paulo")}
                  onChange={(value) =>
                    updateField(
                      infoDay.dayOfWeek,
                      2,
                      "startTime",
                      value ? value.tz("America/Sao_Paulo").format() : ""
                    )
                  }
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                />
                <TimePicker
                  value={dayjs(`2024-01-01T${infoDay.endTime2}`).tz(
                    "America/Sao_Paulo"
                  )}
                  label="Até"
                  onError={(newError) => setErrorEndTime2(newError)}
                  minTime={dayjs(`2024-01-01T${infoDay.startTime2}`)
                    .add(1, "hour")
                    .tz("America/Sao_Paulo")}
                  onChange={(value) =>
                    updateField(
                      infoDay.dayOfWeek,
                      2,
                      "endTime",
                      value ? value.tz("America/Sao_Paulo").format() : ""
                    )
                  }
                  viewRenderers={{
                    hours: renderTimeViewClock,
                    minutes: renderTimeViewClock,
                    seconds: renderTimeViewClock,
                  }}
                />

                <ButtonDeleted
                  handleDeleteItem={() => removeField(infoDay.dayOfWeek, 2)}
                />
              </div>
            )}
          </>
        ) : (
          <p className={styles.msgNoItems}>Indisponível</p>
        )}
      </div>
    </div>
  );
};
